module.exports = __webpack_public_path__ + "img/menu-01.51c2dc2d.png";